import { Grade } from '~/modules/user-profiles/profile-stats';

/**
 * osu!'s ladder. A grade has to mean the same thing on every screen that shows one, so its colour
 * is read from here rather than picked per screen - the profile page, the post-game results and
 * the profile comparison all draw from this map.
 *
 * Applied inline rather than as Tailwind classes: the grade is only known at runtime, which is the
 * same reason `PlayerColorDot` paints a player's colour inline.
 */
export const GRADE_COLOURS: Record<Grade, string> = {
  S: '#ffd94a',
  A: '#88da20',
  B: '#4fc0ff',
  C: '#ff98cb',
  D: '#ff8a3d',
  E: '#ff5a5a',
};

/** A grade's colour at the given hex alpha, for the tints and rings drawn around it. */
export const gradeColour = (grade: Grade, alpha = '') => `${GRADE_COLOURS[grade]}${alpha}`;
